// extracted by mini-css-extract-plugin
export const carouselWrap = "slideshow-module--carouselWrap--1z-Qh";
export const leftArr = "slideshow-module--leftArr--3sErg";
export const rightArr = "slideshow-module--rightArr--1IPJD";
export const carouselContentWrap = "slideshow-module--carouselContentWrap--HNge8";
export const carouselStretch = "slideshow-module--carouselStretch--86dNV";
export const imageWrap = "slideshow-module--imageWrap--3kWQW";
export const dots = "slideshow-module--dots--2sfdv";
export const dot = "slideshow-module--dot--2nd3Z";
export const active = "slideshow-module--active--yJkoq";